import { createSelector } from "reselect";
import { createPolicyForInternalNameSelector } from "src/selectors/data_selectors/policies";

export const exportsTabEnabledSelector = createSelector(
  createPolicyForInternalNameSelector("enable_revision_bulk_pdf_export"),
  policy => {
    return !!policy && policy.attributes.policyValue;
  }
);
